import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=33c82b7d&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=33c82b7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c82b7d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c82b7d')) {
      api.createRecord('33c82b7d', component.options)
    } else {
      api.reload('33c82b7d', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=33c82b7d&scoped=true&", function () {
      api.rerender('33c82b7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G1J2YncAYtzc/JS/teamMember.vue"
export default component.exports